/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { OnboardingControllerHasPaidQueryResponse, OnboardingControllerHasPaid400, OnboardingControllerHasPaid401, OnboardingControllerHasPaid402, OnboardingControllerHasPaid404, OnboardingControllerHasPaid409, OnboardingControllerHasPaid500 } from "../types/OnboardingControllerHasPaid.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getOnboardingControllerHasPaidUrl() {
  const res = { method: 'GET', url: `/onboarding/base/haspaid` as const }
  return res
}

/**
 * @description Checks if the currently authenticated user has paid and for what.If the user has the 'ROLE_PAID' or 'ROLE_USER' authority, a success response object (payment status, tier and subscription name) is returned. Otherwise, a checkout link is provided with a Payment Required status.
 * @summary Check payment status
 * {@link /onboarding/base/haspaid}
 * @deprecated
 */
export async function onboardingControllerHasPaid(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<OnboardingControllerHasPaidQueryResponse, ResponseErrorConfig<OnboardingControllerHasPaid400 | OnboardingControllerHasPaid401 | OnboardingControllerHasPaid402 | OnboardingControllerHasPaid404 | OnboardingControllerHasPaid409 | OnboardingControllerHasPaid500>, unknown>({ method : "GET", url : getOnboardingControllerHasPaidUrl().url.toString(), ... requestConfig })
  return res.data
}